"use client";
import AppCombobox from "@/common/AppCombobox";
import { DEBOUNCE_TIME_IN_MILLISECOND } from "@/const/app.const";
import { AppOptionType } from "@/models";
import { memo, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

const AppInputSelectCombobox = ({
  handleChangeInputDefault,
  selected,
  getSelectByName,
  ...otherProps
}: {
  handleChangeInputDefault: (value: string) => void;
  selected: string;
  getSelectByName: (search: string) => Promise<AppOptionType[]>;
}) => {
  const [dataCombobox, setDataCombobox] = useState<AppOptionType[]>([]);
  const [valueAutoComplete, setValueAutoComplete] = useState("");
  const [flagCheck, setFlagCheck] = useState(false);

  // Hàm debounce để giảm số lần gọi hàm tìm kiếm
  const ChangeCombobox = useDebouncedCallback(async (value) => {
    if (!flagCheck) {
      const data = await getSelectByName(value);
      setDataCombobox(data);
    }
  }, DEBOUNCE_TIME_IN_MILLISECOND);

  useEffect(() => {
    if (selected) {
      getSelectByName(selected).then((data) => {
        if (data.length > 0) {
          setValueAutoComplete((data[0]?.value as string) || "");
          setFlagCheck(true);
        }
        setDataCombobox(data);
      });
    }
  }, [selected, getSelectByName]);

  return (
    <AppCombobox
      options={dataCombobox}
      className="w-full autocomplete-cus"
      classes={{ paper: "paper-autocomplete-cus" }}
      value={valueAutoComplete}
      onChange={(event, item) => {
        setFlagCheck(true);
        setValueAutoComplete(item?.value);
        handleChangeInputDefault(item?.value);
      }}
      onInputChange={(event, value) => {
        if (value.trim().length >= 3) {
          setFlagCheck(false);
          ChangeCombobox(value);
        }
      }}
      size={"small"}
      {...otherProps}
    />
  );
};

export default memo(AppInputSelectCombobox);
